export default __webpack_public_path__ + "static/media/top5Logo.de47072e.png";